import { registerEnumType } from 'type-graphql'

export enum ModelFamilyEnum {
  OpenAiGpt4 = 'OpenAiGpt4',
  OpenAiGpt5 = 'OpenAiGpt5',
  GoogleGemini2 = 'GoogleGemini2',
  GoogleGemini3 = 'GoogleGemini3',
  AnthropicClaude4 = 'AnthropicClaude4',
  DeepSeekV3 = 'DeepSeekV3',
  MiniMaxM2 = 'MiniMaxM2',
  MoonshotKimi2 = 'MoonshotKimi2',
  /** A model id carrying no version token (e.g. `glm-ocr`) takes vendor + product line alone, distinct from a versioned generation like `ZaiGlm4`. */
  ZaiGlm = 'ZaiGlm',
  ZaiGlm4 = 'ZaiGlm4',
}

registerEnumType(ModelFamilyEnum, {
  name: 'ModelFamilyEnum',
  description:
    'Vendor + product line + major generation classification of a ModelRate row (e.g. OpenAiGpt5, GoogleGemini3), read off the version token in the model id. Reporting only — never a routing input.',
})
